import { Box, Flex, Text, Spacer, Link, Icon } from '@chakra-ui/react';
import { ArrowUpRightIcon } from '@heroicons/react/24/solid';
import { NavLink, useParams } from 'react-router-dom';
import useWorkspace from '@/lib/hooks/use-workspace';
import useCurrentUser from '@/lib/hooks/use-current-user';
import useIsInAdminGroup from '@/lib/hooks/use-is-in-admin-group';
import useIsCancelled from '@/lib/hooks/use-is-cancelled';
import { totalDays } from '@/lib/helpers';

export default function Banner() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { workspace } = useWorkspace();
  const { user } = useCurrentUser();
  const isInAdminGroup = useIsInAdminGroup();
  const isCancelled = useIsCancelled();

  const trialEndDays =
    workspace && workspace.plan_end_date ? totalDays(workspace.plan_end_date) : 0;

  return (
    <>
      {!user?.has_payment_methods && !isCancelled && trialEndDays > 0 && trialEndDays <= 14 && (
        <Box bg={'warning'} w={'full'} px={5} py={1} color={'white'}>
          <Flex>
            <Text fontSize={'xs'} fontWeight={'bold'}>
              Trial Mode
            </Text>
            <Spacer />
            <Text display={{ base: 'none', lg: 'block' }} fontSize={'xs'}>
              You're using trial mode. Your trial ends in
              <strong> {trialEndDays}</strong> Days.
            </Text>
            <Spacer />
            {isInAdminGroup && (
              <Link asChild color='white' fontWeight='medium' fontSize='xs'>
                <NavLink to={`/${workspaceId}/settings`}>
                  Settings
                  <Icon as={ArrowUpRightIcon} w={4} h={4} />
                </NavLink>
              </Link>
            )}
          </Flex>
        </Box>
      )}
    </>
  );
}
